
/**
 * @fileOverview NavigationRelocationController Module File This file handles the implementation of
 * the ContentRelocationController as it relates to the primary and global navigation.  This is a
 * very specific implementation that is not configurable through data-tags, the configuration is being
 * set up in this module in order to encapsulate the logic away from App.js
 *
 * @author jmaki
 * @version 1.0
 */


(function (context) {
    'use strict';

    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;

    define('controllers/NavigationRelocationController',['require','jquery','lib/Util','controllers/ContentRelocationController','GlobalResizeListener'],function (require) {

        var $ = require('jquery');
        var Util = require('lib/Util');
        var ContentRelocationController = require('controllers/ContentRelocationController');
        var GlobalResizeListener = require('GlobalResizeListener');

        /**
         * Description
         *
         * @name NavigationRelocationController
         * @class NavigationRelocationController a factory for creating ContentRelocationControllers for the navigation
         * @constructor
         * @param {App} app a reference to the application
         *
         * @since 1.0
         */
        var NavigationRelocationController = function () {
            this.relocationControllers = undefined;
            //initialize the resize listener
            this.globalResizeListener = GlobalResizeListener.getResizeListener();
            this.init();
        };

        /**
         * Initializes the UI Component View
         * Runs a single setupHandlers call, followed by createChildren and layout
         *
         * @returns {NavigationRelocationController}
         * @since 1.0
         */
        NavigationRelocationController.prototype.init = function () {
            this.isEnabled = false;

            return this.configureControllers()
                .setupControllers()
                .enable()
                .triggerCurrentContext();
        };


        /**
         *
         * @return {NavigationRelocationController}
         */
        NavigationRelocationController.prototype.configureControllers = function () {
            return this;
        };

        /**
         *
         * @return {NavigationRelocationController}
         */
        NavigationRelocationController.prototype.triggerCurrentContext = function () {
            this.globalResizeListener.triggerCurrentContext();
        };

        /**
         * Binds the scope of any handler functions
         * Should only be run on initialization of the view
         *
         * @returns {NavigationRelocationController}
         * @since 1.0
         */
        NavigationRelocationController.prototype.setupControllers = function () {
            var crc3 = new ContentRelocationController('#js-gsnTertiary', {target: '#js-mobileMenuWrapper', event: 'smallContext', append: true});
            var crc4 = new ContentRelocationController('#js-gsnTertiary', {target: '#js-mobileMenuWrapper', event: 'mediumContext', append: true});
            var crc1 = new ContentRelocationController('#js-gsnTertiary', {target: '#js-utilityNav', event: 'largeContext', append: false});
            var crc2 = new ContentRelocationController('#js-gsnTertiary', {target: '#js-utilityNav', event: 'luxuryContext', append: false});

            var crc5 = new ContentRelocationController('#js-psn', {target: '#js-navigation', event: 'largeContext', append: false});
            var crc6 = new ContentRelocationController('#js-psn', {target: '#js-navigation', event: 'luxuryContext', append: false});
            var crc8 = new ContentRelocationController('#js-psn', {target: '#js-mobileMenuWrapper', event: 'mediumContext', append: false});
            var crc7 = new ContentRelocationController('#js-psn', {target: '#js-mobileMenuWrapper', event: 'smallContext', append: false});

            this.relocationControllers = [crc1, crc2, crc3, crc4, crc5, crc6, crc7, crc8];
            return this;
        };

        /**
         * returns the collection of contentRelocationControllers in case it is needed by the application
         * @return {Array}
         */
        NavigationRelocationController.prototype.getRelocationControllers = function () {
            return this.relocationControllers;
        };

        /**
         * Enables the module
         * Performs any event binding to handlers
         * Exits early if it is already enabled
         *
         * @returns {NavigationRelocationController}
         * @since 1.0
         */
        NavigationRelocationController.prototype.enable = function () {
            if (this.isEnabled) {
                return this;
            }

            this.isEnabled = true;

            return this;
        };

        /**
         * Disables the view
         * Tears down any event binding to handlers
         * Exits early if it is already disabled
         *
         * @returns {NavigationRelocationController}
         * @since 1.0
         */
        NavigationRelocationController.prototype.disable = function () {
            if (!this.isEnabled) {
                return this;
            }

            this.isEnabled = false;

            return this;
        };

        return NavigationRelocationController;
    });

}(MMMRequire));

